import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeadingXxs, LabelXs, TextS } from 'frontend/js/modules/infra/dls/components/typography';
import styles from './styles.module.scss';
export var MetricCard = function (_a) {
    var title = _a.title, value = _a.value, subtitle = _a.subtitle;
    return (_jsxs("div", { className: styles['metric-card'], children: [_jsx(LabelXs, { color: "secondary", className: styles['metric-title'], children: title }), _jsxs("div", { className: styles['metric-info-container'], children: [_jsx(HeadingXxs, { color: "primary", children: value }), subtitle && _jsx(TextS, { color: "tertiary", children: subtitle })] })] }));
};
